var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { ReactReduxContext } from 'react-redux';
/* eslint-disable react/prefer-stateless-function, eqeqeq */
import getInjectors from './reducerInjectors';
/**
 * Dynamically injects a reducer
 *
 * @param {string} key A key of the reducer
 * @param {function} reducer A reducer that will be injected
 *
 */
export var injectReducer = function (_a) {
    var key = _a.key, reducer = _a.reducer, _b = _a.autoReset, autoReset = _b === void 0 ? true : _b;
    return function (WrappedComponent) {
        var ReducerInjector = function (props) {
            var isInjected = useInjectReducer({ key: key, reducer: reducer, autoReset: autoReset });
            if (!isInjected) {
                return null;
            }
            return _jsx(WrappedComponent, __assign({}, props));
        };
        ReducerInjector.displayName = "withReducer(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
        return hoistNonReactStatics(ReducerInjector, WrappedComponent);
    };
};
export default process.env.NODE_ENV == 'test'
    ? function () { return function (component) { return component; }; }
    : injectReducer;
/** taken from: https://github.com/react-boilerplate/react-boilerplate/blob/master/app/utils/injectReducer.js */
var useInjectReducer = function (_a) {
    var key = _a.key, reducer = _a.reducer, _b = _a.autoReset, autoReset = _b === void 0 ? true : _b;
    var _c = useState(false), isInjected = _c[0], setIsInjected = _c[1];
    var context = useContext(ReactReduxContext);
    useEffect(function () {
        // componentDidMount
        var injectors = getInjectors(context.store);
        injectors.injectReducer(key, reducer);
        setIsInjected(true);
        return function () {
            // componentWillUnmount
            if (autoReset) {
                injectors.resetReducer(key);
            }
        };
    }, [context, autoReset, key, reducer]);
    return isInjected;
};
export { useInjectReducer };
